import { ALL_LEADS_REPORTS } from "../../constant/ActionType";

export default function OverAllLeadsReportsReducer(
    state = {
        leadsoverallrepdata: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_LEADS_REPORTS:
            return {
                ...state,
                leadsoverallrepdata: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
